import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';

import RenderingErrorBoundary from 'components/RenderingErrorBoundary';
import LoadingOverlay from 'components/shared/table/LoadingOverlay';
import ViewSummarization from 'components/summarization/ViewSummarization';
import SuspenseErrorBoundary from 'components/SuspenseErrorBoundary';
import { SummarizationProvider } from 'context/summarization';

export default function ViewSummarizationPage() {
  return (
    <Container>
      <SuspenseErrorBoundary fallback={<Navigate to='/summarizations' replace />}>
        <Suspense fallback={<Loading />}>
          <SummarizationProvider>
            <RenderingErrorBoundary>
              <ViewSummarization />
            </RenderingErrorBoundary>
          </SummarizationProvider>
        </Suspense>
      </SuspenseErrorBoundary>
    </Container>
  );
}

const Container = styled.div`
  background: white;
  height: 100%;
`;

const Loading = styled(LoadingOverlay)`
  position: relative;
`;
